<template>
  <div>
    <PageHeader title="Devis" />
    <LeadsIndex :storeId="selectedStoreId" />
  </div>
</template>

<script>
import { PageHeader } from "@estaly/ui";
import LeadsIndex from "@/components/leads/LeadsIndex.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    LeadsIndex,
    PageHeader,
  },
  computed: {
    ...mapGetters("store", ["selectedStoreId"]),
  },
};
</script>
